/**
 * `/raporty/$templateId` — the survey editor on a form that exists.
 *
 * ── The parameter is parsed HERE, and `null` means "not a template id" ───────────────────────
 * The screen takes a target rather than reading `useParams` itself, because it is mounted by two
 * routes and `/raporty/nowa` has no parameter at all. Parsing at the route file keeps that
 * difference a wiring detail: `null` reaches the screen as an unusable address and gets the error
 * state instead of firing a request that could only 404. `_shell.plans.$planId.tsx` is the sibling
 * this follows.
 *
 * The raw parameter travels with the parsed one so the screen's heading has something to fall back
 * to — without it `/raporty/abc` would title its tab with nothing at all.
 */

import { createFileRoute, useParams } from '@tanstack/react-router';

import { SurveyEditorScreen } from '~/pages/reports';

export const Route = createFileRoute('/_shell/raporty/$templateId')({
  component: SurveyEditorRoute,
});

function SurveyEditorRoute() {
  const { templateId } = useParams({ from: '/_shell/raporty/$templateId' });
  const id = Number(templateId);
  return (
    <SurveyEditorScreen
      target={{
        kind: 'stored',
        templateId: Number.isInteger(id) && id > 0 ? id : null,
        rawId: templateId,
      }}
    />
  );
}
